import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navigation_bar.css';

const NavigationBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navigation-bar-3d ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-3d-wrapper">
        <div className="nav-3d-logo">
          <Link to="/" onClick={closeMobileMenu}>
            <span className="logo-3d-text">Rabi Aryal</span>
          </Link>
        </div>

        <div className={`nav-3d-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <ul className="nav-3d-list">
            <li className="nav-3d-item">
              <Link
                to="/"
                className={`nav-3d-link ${location.pathname === '/' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                <span className="link-text">Home</span>
              </Link>
            </li>
            <li className="nav-3d-item">
              <Link
                to="/about"
                className={`nav-3d-link ${location.pathname === '/about' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                <span className="link-text">About</span>
              </Link>
            </li>
            <li className="nav-3d-item">
              <Link
                to="/skills"
                className={`nav-3d-link ${location.pathname === '/skills' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                <span className="link-text">Skills</span>
              </Link>
            </li>
            <li className="nav-3d-item">
              <Link
                to="/projects"
                className={`nav-3d-link ${location.pathname === '/projects' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                <span className="link-text">Projects</span>
              </Link>
            </li>
            <li className="nav-3d-item">
              <Link
                to="/blogs"
                className={`nav-3d-link ${location.pathname === '/blogs' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                <span className="link-text">Blogs</span>
              </Link>
            </li>

          </ul>
        </div>

        <div className="nav-3d-actions">
          <Link to="/contact" className="cta-3d-button">
            <span className="cta-3d-text">Let's Talk</span>
          </Link>
        </div>

        <button
          className={`mobile-menu-toggle-3d ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-3d-line"></span>
          <span className="hamburger-3d-line"></span>
          <span className="hamburger-3d-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default NavigationBar;
